import { useEffect, useState } from 'react';
import { Card, CardBody, List, ListInlineItem } from 'reactstrap';
import '@src/@core/scss/layouts/jumbotron/jumbotron.scss';
import logoBanner from '@src/assets/images/logo/banner_transparent_light.png';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import { ArrowDown } from 'react-feather';

type Props = {
  navbar?: JSX.Element;
};

const Jumbotron = (props: Props) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <Card className="jumbotron-1-bg">
      {props.navbar}
      <CardBody className="text-center">
        <img className="logo-banner" src={logoBanner} alt="" />
        <p className="pt-2">
          Find, compare, & book massages with the most sophistocated rate
          booking engine.
        </p>
        <List className="pt-2">
          <ListInlineItem>
            <a
              className="download-btn"
              href="https://apps.apple.com/us/app/spaccurate-spa-accurate-rate/id1661816920"
            >
              <FaApple size="20px" className="download-icon" /> Download for iOS
            </a>
          </ListInlineItem>
          <ListInlineItem>
            <a
              className="download-btn"
              href="https://play.google.com/store/apps/details?id=com.spaccurate.customer_mobile"
            >
              <FaGooglePlay size="20px" className="download-icon" /> Download
              for Android
            </a>
          </ListInlineItem>
        </List>
        <List className="location-below">
          <a href="#locations">
            <ListInlineItem>
              <ArrowDown className="arrow-down" />
            </ListInlineItem>
            <ListInlineItem>
              <p className="select-below">Or select a location below</p>
            </ListInlineItem>
            <ListInlineItem>
              <ArrowDown className="arrow-down" />
            </ListInlineItem>
          </a>
        </List>
      </CardBody>
    </Card>
  );
};

export default Jumbotron;
